import { createApp } from 'vue'
import options from './SearchAndCTA.options'

const el = '.kb-component--search-and-cta'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SearchAndCTADOM) => {
            const template = SearchAndCTADOM.outerHTML
            options.template = template
            const component = createApp(options, {
                guid: SearchAndCTADOM.dataset.guid
            }).use(Store)
            component.mount(SearchAndCTADOM)
        })
    }
}
